import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import profilReducer from "./slices/profileSlice";
import bookReducer from "./slices/bookSlice";
import categoryReducer from './slices/categorySlice'

const rootReducer = combineReducers({
    auth:authReducer,
    profile:profilReducer,
    book:bookReducer,
    category:categoryReducer,
})

export default rootReducer;